<template>
    <div class='touch-content'>
        <div class='reservation-area'>
            <div class='top-info-box'>
                <span class='info-txt'>현재시간 : {{ nowDate }} {{ nowTime }}</span>
            </div>
            <!-- 수업 없을 경우 -->
            <div class='view-box'>
                <p class='no-msg'><strong>[{{ name }}]</strong>회원님<br>금일 출석 할 수업이 없습니다.</p>
                <button class='back-btn' @click='back'>처음으로</button>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';

export default {
    name: 'touchNodata',
    data() {
        return {
            nowDate: moment().format('YYYY.MM.DD'),
            nowTime: moment().format('hh:mm:ss'),
            name: this.$route.query.name,
        };
    },
    mounted() {
        setInterval(() => {
            this.nowTime = moment().format('hh:mm:ss');
        }, 1000);

        setTimeout(() => {
            this.back();
        }, 1000);
    },
    methods: {
        back() {
            this.$router.push({ path: 'main' }); // 뒤로가기
        },
    },
};
</script>
<style lang='scss' scoped>
</style>
